import type { CameraMode } from '@/gameplay/types'

const KEY = 'miner:settings:v1'

export interface PlayerSettings {
  lookSensitivity: number
  invertY: boolean
  leftHandMobile: boolean
  masterVolume: number
  showControlsHints: boolean
  hideBriefing: boolean
  preferTouch: boolean | null
  cameraMode: CameraMode
}

export const DEFAULT_SETTINGS: PlayerSettings = {
  lookSensitivity: 1,
  invertY: false,
  leftHandMobile: false,
  masterVolume: 0.7,
  showControlsHints: true,
  hideBriefing: false,
  preferTouch: null,
  cameraMode: 'fps',
}

export function loadSettings(): PlayerSettings {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return { ...DEFAULT_SETTINGS }
    return { ...DEFAULT_SETTINGS, ...(JSON.parse(raw) as Partial<PlayerSettings>) }
  } catch {
    return { ...DEFAULT_SETTINGS }
  }
}

export function saveSettings(settings: PlayerSettings): void {
  localStorage.setItem(KEY, JSON.stringify(settings))
}
